import { bigCommerceFetch } from "."

import { getStoreCategorieTreeQuery } from "./queries/category"
import { getMenuQuery } from "./queries/menu"

export function mapBigcommerceCategoriesToNavigation(
    bigCommerceCategories: BigCommerceCategory[]
): NavigationElement[] {
    function convertCategoryToNavigationEntry(category: BigCommerceCategory): NavigationElement {
        const navEl = {
            name: category.name,
            page: "/collections" + category.path,
            external: false,
            elements: category.children?.map(convertCategoryToNavigationEntry),
            type: "bigcommerce",
        }
        return navEl
    }

    return bigCommerceCategories.map(convertCategoryToNavigationEntry)
}

export async function getCategories(): Promise<BigCommerceCategory[]> {
    const res = await bigCommerceFetch<BigCommerceCategoryOperation>({
        query: getStoreCategorieTreeQuery,
    })
    return res.body.data.site.categoryTree
}

export const getCategoryEntityIdbyHandle = async (handle: string) => {
    const resp = await bigCommerceFetch<BigCommerceMenuOperation>({
        query: getMenuQuery,
    })
    const recursiveFindCollectionId = (list: BigCommerceCategoryTreeItem[], slug: string): number => {
        const collectionId = list
            .flatMap((item): number | null => {
                if (item.path.includes(slug!)) {
                    return item.entityId
                }

                if (item.children && item.children.length) {
                    return recursiveFindCollectionId(item.children!, slug)
                }

                return null
            })
            .filter((id) => typeof id === "number")[0]

        return collectionId!
    }

    return recursiveFindCollectionId(resp.body.data.site.categoryTree, handle)
}
